export default class DymaticTagGroupItemModel {
  originalData = null;
  shouldDynamicTagsTwoLines = true;
  constructor(data, landscapeJSXElements, landscapeRichTextContents, extraCardData) {
    this.originalData = data;
    this.shouldDynamicTagsTwoLines = Boolean(extraCardData?.shouldDynamicTagsTwoLines);
  }
}
